export { default } from './ExpansionPanelDetails';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ExpansionPanelDetails/index.js
// module id = 326
// module chunks = 0